const stickyHeader = {
  header: document.getElementById('gdHeader') as HTMLElement,
  mainContent: document.getElementById('main-content') as HTMLElement,
  btn: document.getElementById('jsToggleMenu') as HTMLElement,
  descNav: document.getElementById('jsDescNav') as HTMLElement,
  popups: document.querySelectorAll(
    '.jsStickyPopup',
  ) as NodeListOf<HTMLElement>,
  lastScrollTop: 0,

  init() {
    this.setClass();
    this.toggleMainMenu();
  },

  
  toggleMainMenu() {
    if(this.btn) {
    this.btn.addEventListener('click', () => {
      if(this.btn.dataset.open === 'false') {
        this.descNav.classList.add('activeClass'); 
        this.btn.dataset.open = 'true';
      } else {
        this.descNav.classList.remove('activeClass'); 
        this.btn.dataset.open = 'false';
      }
    }) 
    }
  },


  setClass() {
    document.addEventListener('scroll', () => {
      const st = window.scrollY || document.documentElement.scrollTop;
      if (st > this.lastScrollTop) {
        this.header.classList.remove('up');
        this.header.classList.add('down');
        this.mainContent.classList.remove('up');
        this.mainContent.classList.add('down');
        this.popups.forEach((popup) => {
          popup.classList.add('activeScroll');
        });

      } else {
        this.header.classList.add('up');
        this.header.classList.remove('down');
        this.mainContent.classList.add('up');
        this.mainContent.classList.remove('down');
        this.popups.forEach((popup) => {
          popup.classList.add('activeScroll');
        });

      }
      this.lastScrollTop = st <= 0 ? 0 : st;

      if (window.scrollY === 0) {
        this.header.classList.remove('up');
        this.header.classList.remove('down');
        this.mainContent.classList.remove('up');
        this.mainContent.classList.remove('down');
        this.popups.forEach((popup) => {
          popup.classList.remove('activeScroll');
        });
      }

    });
  },
};

export default stickyHeader;
